<template>
  <v-select
    chips
    :multiple="multiple"
    :items="items"
    :value="selectedMediaIds"
    item-text="name"
    item-value="id"
    v-bind="$attrs"
    @blur="onBlur"
    @focus="$emit('focus')"
    @input="acceptSelection"
  ></v-select>
</template>

<script>
import { toArray } from '@/utils';
import isObject from 'lodash/isObject';

/**
 * Media Selector.
 *
 * @property {(siteId|siteId[])} [value] The initial selected sites.
 */
export default {
  name: 'nx-media-selector',
  props: {
    limit: {
      type: Number,
    },
    value: {
      type: [Array, Number, String, Object],
    },
  },
  computed: {
    items() {
      return this.$store.getters.availableMedias;
    },
    multiple() {
      return !this.limit || this.limit !== 1;
    },
    selectedItems() {
      const values = toArray(this.value);
      return toArray(this.items)
        .filter(site => values
          .map(item => parseInt(isObject(item) ? item.id : item, 10))
          .includes(site.id))
        .map(item => item.id);
    },
    hasSelectedItems() {
      return toArray(this.value).length > 0;
    },
    selectedMediaIds() {
      return this.multiple ? toArray(this.selectedItems) : this.selectedItems[0];
    },
  },
  methods: {
    acceptSelection(selectedMediaIds) {
      this.$emit('input', toArray(selectedMediaIds));
    },
    onBlur() {
      this.$emit('blur', this.selectedItems);
    },
  },
};
</script>
